var map = {
	"./arrow-left.svg": 649,
	"./arrow-right.svg": 515,
	"./arrow.svg": 537,
	"./bookmark_empty.svg": 672,
	"./bookmark_full.svg": 772,
	"./buy.svg": 557,
	"./fb.svg": 171,
	"./logo.svg": 684,
	"./mail.svg": 834,
	"./main-light.svg": 234,
	"./zoom-in.svg": 348
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 646;